import {
  Grid,
  CircularProgress,
  Button,
  LinearProgress,
  Typography,
} from "@mui/material";

const GetTracking = ({ isLoading, progress, onRetry, onCloseResults }) => {
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Button
          type="submit"
          variant="outlined"
          className="mg-l-10"
          onClick={onRetry}
          disabled={isLoading}
          startIcon={
            isLoading ? <CircularProgress size={20} color="inherit" /> : null
          }
        >
          {isLoading ? "Intentando reasignar..." : "Reintentar Tracking"}
        </Button>
      </Grid>

      {progress.running && (
        <Grid item style={{ marginTop: "20px" }}>
          <h4>
            Procesando entregas: {progress.processed}/{progress.total}
          </h4>
          <LinearProgress
            variant="determinate"
            value={(progress.processed / progress.total) * 100}
          />
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginTop: "8px" }}
          >
            Lote: {progress.currentChunk}/{progress.totalChunks}
          </Typography>
          <Typography variant="body2">
            ✅ Éxito: {progress.success.length} | ❌ Fallos:{" "}
            {progress.failed.length}
          </Typography>
        </Grid>
      )}

      {!progress.running && progress.total > 0 && (
        <Grid item style={{ marginTop: "20px" }}>
          <h4>🎉 Proceso completo</h4>
          <p>✅ Éxito: {progress.success.length}</p>
          <p>❌ Fallos: {progress.failed.length}</p>
          <Button
            variant="outlined"
            className="mg-l-10"
            onClick={onCloseResults}
          >
            Cerrar
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default GetTracking;
